<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR EQUIPAMENTO' : 'NOVO EQUIPAMENTO BIOMÉTRICO'" titleIcon="fas fa-door-open">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Catraca do portão principal"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Identificador (serial ou MAC)" prop="identificador" :rules="$requiredBlur">
                            <el-input v-model="dados.identificador" placeholder="CAT-001"></el-input>
                            <small>É o que o equipamento envia em cada requisição.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Tipo" prop="tipo" :rules="$requiredChange">
                            <el-select v-model="dados.tipo" style="width: 100%;">
                                <el-option v-for="t in tipos" :key="t" :value="t" :label="rotuloTipo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Escola" prop="instituicao_id" :rules="$requiredChange">
                            <el-select v-model="dados.instituicao_id" filterable style="width: 100%;" :disabled="modoEdicao">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                            <small v-if="modoEdicao">A escola não muda por edição — mover o aparelho de unidade é um cadastro novo, com token novo.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Local">
                            <el-input v-model="dados.local" placeholder="Portão principal"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7">
                        <el-form-item label="Direção registrada" prop="direcao" :rules="$requiredChange">
                            <el-select v-model="dados.direcao" style="width: 100%;">
                                <el-option value="ambos" label="Entrada e saída"></el-option>
                                <el-option value="entrada" label="Somente entrada"></el-option>
                                <el-option value="saida" label="Somente saída"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="IP (opcional)">
                            <el-input v-model="dados.ip" placeholder="192.168.0.50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Situação">
                            <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                            <div><small class="u-text-muted">Equipamento inativo não autentica — deixa de registrar eventos imediatamente.</small></div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-alert v-if="!modoEdicao" type="info" :closable="false" class="u-mb-15"
                    title="Ao salvar, o token de acesso será exibido UMA única vez."
                    description="Copie-o antes de fechar: ele é gravado apenas como hash e não pode ser recuperado depois."></el-alert>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/biometria/equipamento"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>

            <el-dialog title="Token do equipamento" :visible.sync="dialogoToken" width="620px"
                :close-on-click-modal="false" :show-close="false">
                <el-alert type="warning" :closable="false" class="u-mb-15"
                    title="Copie o token agora." :description="avisoToken"></el-alert>
                <el-input v-model="tokenGerado" readonly>
                    <el-button slot="append" icon="el-icon-document-copy" @click="copiar">COPIAR</el-button>
                </el-input>
                <small class="u-text-muted">
                    Configure no equipamento o cabeçalho <code>Authorization: Bearer &lt;token&gt;</code>.
                </small>
                <span slot="footer"><el-button type="primary" @click="concluir">JÁ COPIEI</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO J — itens 127, 128 e 129. */
export default {
    data: () => ({
        tipos: ['catraca', 'totem', 'camera', 'tablet'], instituicoes: [],
        dialogoToken: false, tokenGerado: '', avisoToken: '',
        dados: { nome: '', identificador: '', instituicao_id: null, tipo: '', local: '',
                 direcao: 'ambos', ip: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [0, 1, 4, 5, 6, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = (r.data && r.data.instituicoes) ? r.data.instituicoes : [] })
         .catch(e => this.$store.commit('throwException', e))

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/biometria/equipamento')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotuloTipo (t) {
            return { catraca: 'Catraca', totem: 'Totem', camera: 'Câmera', tablet: 'Tablet' }[t] || t
        },
        copiar () {
            const el = document.createElement('textarea')
            el.value = this.tokenGerado
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            el.remove()
            window.eventBus.$emit('alert', { msg: 'Token copiado.', type: 'success' })
        },
        concluir () {
            this.dialogoToken = false
            this.$router.push('/admin/biometria/equipamento')
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/equipamento-biometrico/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                    // Na criação o token aparece uma única vez — a tela só sai depois do "já copiei".
                    if (!this.modoEdicao && r.data.token) {
                        this.tokenGerado = r.data.token
                        this.avisoToken = r.data.aviso_token
                        this.dialogoToken = true
                        return
                    }

                    window.eventBus.$emit('alert', { msg: r.data.mensagem || 'Equipamento salvo.', type: 'success' })
                    this.$router.push('/admin/biometria/equipamento')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
